export enum FilterQueryOperator {
  Equal = "eq",
  NotEqual = "neq",
  LessThan = "lt",
  GreaterThan = "gt",
  Like = "like",
  TypeIs = "typeis",
  TypeIsNot = "typeisnot",
}

export enum FilterCombinationType {
  And = "and",
  Or = "or",
}

export type FilterQueryValue = { [key in FilterQueryOperator]?: string };
export type FilterQuery = { [key: string]: FilterQueryValue };
